module.exports = __webpack_public_path__ + "img/q8.988a21cf.png";